module.exports = __webpack_public_path__ + "static/media/cnx-pay-Visa.3532d5db.svg";